// extracted by mini-css-extract-plugin
module.exports = {"half":"TxtImg-module--half--1nC4W","third":"TxtImg-module--third--11x1X","imgFirst":"TxtImg-module--imgFirst--1lHHr"};